export default "__VITE_ASSET__Po3QNc6s__"